import React from 'react';

import { Chip } from '@infoods/lifebase-ui';
import classes from './AssignedToBlock.module.scss';
import { NoteUser } from '../../../../interfaces/note';

type AssignedToBlockProps = {
  users: NoteUser[];
};

const AssignedToBlock = ({ users }: AssignedToBlockProps) => {
  return (
    <div className={classes.container}>
      <p className={classes.label}>Assigned to:</p>
      {users.map((user) => (
        <Chip
          key={user.id}
          label={user.fullName}
          className="private-info"
          size="extraSmall"
          color="info"
        />
      ))}
    </div>
  );
};

export { AssignedToBlock };
